import React from 'react';
import { Dropdown, Grid, Input, Card } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import DeleteIcon from '@material-ui/icons/Delete';

class Item extends React.Component {

  state = {
    spareOption: [],
    brandOption: [],
    load: false,
    message: '',
    open: true
  }

  componentDidMount() {
    let context = this;
    $("#qty"+context.props.id).keyup(function(event) {
      if (event.keyCode === 9) {
        context.props.addItem();
      }
    });
  }

  partcode = event => {
    let val = event.target.value;
    val = val.split('->')[2];
    this.getPartsAndBrand(val, event.target.value);
  };

  getPartsAndBrand(value, dropdownvalue) {
    let context = this;
    let data = this.props.data;
    let partno, brand_id, partname, brand_name, part_id, mrp, tax, dnp, ava_stocks;
    data.map((z) => {
      if (z.part_id == value) {
        partno = z.partno;
        ava_stocks = z.ava_stocks;
        brand_id = z.brand_id;
        partname = z.spare_name;
        brand_name = z.brand_name;
        part_id = z.part_id;
        mrp = z.mrp;
        tax = z.tax;
        dnp = z.dnp;
      }
    });
    this.props.addItemArray(context.props.id, part_id, partno, brand_id,
                            partname, brand_name, value, dropdownvalue, mrp, tax, dnp, ava_stocks)

  }

  getStocks(value, partno) {
    alert(partno)
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Stocks!!!'
    });
    let data1 = { 'partno': partno, 'brand_id': value, 'branch': this.props.branch };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/getstocks.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          let stock;
          let id;
          let mrp, tax;
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              stock = data[i].stock;
              id = data[i].id;
            }
            context.props.addItemArray1(context.props.id, id);
            context.setState({
              stockavaliable: data,
              id: id,
              load: false,
              color: 'green'
            });
          }
          else {
            context.setState({
              stocks: 'No Stock(s)',
              load: false,
              color: 'red',
            });
          }
        }
        catch (e) {
        }
      },
      error: function(err)
      {
        context.setState({
          load: false
        });
      }
    });
  }

  onChanges = (type) => (f, { value }) => {
    this.props.updateItem(this.props.id, type, value);
    this.setState({ [type]: value });
  }

  onChangess = (type) => (f, { value }) => {
    if (value <= 0) {
      document.getElementById("qty"+this.props.id).value = "";
      alert('You are entering NEGATIVE (or) ZERO stock!!!');
      return;
    }
    else {
      this.props.updateItem(this.props.id, type, value);
      this.setState({ [type]: value });
    }
  }

  render() {
    let dnp = this.props.item.mrp;
    let qty = this.props.item.stock;
    let total = 0;
    try {
      dnp = Number(dnp).toFixed(2);
      qty = Number(qty).toFixed(2);
      total = (dnp * qty).toFixed(2);
    } catch (e) {

    }
    return (
      <tbody>
        <Loading load={this.state.load} message={this.state.message} />
          <tr>
            <td><center>{this.props.count}</center></td>
            <td>
              <center>
                <div>
                  <datalist id="suggestions">
                      {this.props.partcodeOption.map((x) => {
                        return (
                          <option id='box'>{x.text}</option>
                        )
                      })}
                  </datalist>
                  <input style={{height: 35, width: '100%'}} onChange={this.partcode} autoComplete="on"
                  list="suggestions" value={this.props.item.dropdownvalue} id={this.props.id}/>
                </div>
              </center>
            </td>
            <td><center>{this.props.item.brand_name}</center></td>
            <td>
              <center>
                <Input type="number" placeholder={this.props.item.stocksAvailable} id={"qty"+this.props.id}
                value={this.props.item.stock} fluid onChange={this.onChangess('stock')} focus />
              </center>
            </td>
            <td><center>{dnp}</center></td>
            <td><center>{total}</center></td>
            <td>
              <center>
                <DeleteIcon onClick={this.props.remove(this.props.id)} />
              </center>
            </td>
          </tr>
      </tbody>
    );
  }
}

export default Item;
